// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.

/**
 * connections client for the X API.
 *
 * This module provides a client for interacting with the connections endpoints of the X API.
 */

import { Client, ApiResponse, RequestOptions } from '../client.js';
import { 
    Paginator, 
    PostPaginator, 
    UserPaginator, 
    EventPaginator
} from '../paginator.js';
import {
DeleteAllResponse,
} from './models.js';




/**
 * Client for connections operations
 * 
 * This client provides methods for interacting with the connections endpoints
 * of the X API. It handles authentication, request formatting, and response
 * parsing for all connections related operations.
 * 
 * @category connections
 */
export class ConnectionsClient {
    private client: Client;

    /**
     * Creates a new connections client instance
     * 
     * @param client - The main X API client instance
     */
    constructor(client: Client) {
        this.client = client;
    }

    /**
     * Normalize options object to handle both camelCase and original API parameter names
     * Only accepts: proper camelCase (tweetFields) and original API format (tweet.fields)
     */
    private _normalizeOptions<T extends Record<string, any>>(options: T, paramMappings: Record<string, string>): T {
        if (!options || typeof options !== 'object') {
            return options;
        }
        
        const normalized: any = { ...options };
        
        // For each parameter mapping (original -> proper camelCase)
        for (const [originalName, camelName] of Object.entries(paramMappings)) {
            // Check if original format is used (e.g., 'tweet.fields', 'tweet_fields')
            if (originalName in normalized && !(camelName in normalized)) {
                normalized[camelName] = normalized[originalName];
                delete normalized[originalName];
            }
            // Also check for proper camelCase (e.g., 'tweetFields')
            // If it's already in proper camelCase, keep it (no conversion needed)
            // The camelName is already the proper camelCase format
        }
        
        return normalized as T;
    }



  /**
   * Terminate all connections
   * Terminates all active streaming connections for the authenticated application.



   * @returns {Promise<DeleteAllResponse>} Promise resolving to the API response
   */
    // Overload 1: Default behavior (unwrapped response)
    async deleteAll(
        
        
        
        
        
        
        
        
    ): Promise<DeleteAllResponse> {
        // Normalize options to handle both camelCase and original API parameter names
        
        const requestOptions = {};
        

        // Build the path with path parameters
        let path = '/2/connections/all';
        

        // Build query parameters
        const params = new URLSearchParams();
        

        // Prepare request options
        const finalRequestOptions: RequestOptions = {
            
            
            // Pass security requirements for smart auth selection
            security: [
                
                {
                    
                    'BearerToken': [],
                    
                }
                
            ],
            
            
            // No optional parameters, using empty request options
            
        };

        return this.client.request<DeleteAllResponse>(
            'DELETE',
            path + (params.toString() ? `?${params.toString()}` : ''),
            finalRequestOptions
        );
    }







}
